<script setup>
  const { data } = defineProps(['data']);
</script>

<!----------------------------------------------------------------------------->

<template>
  <EventDetailCard><EventDetailFight :card="data" /></EventDetailCard>
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped>
  @include break-min-small {
    :deep(> .card) {
      padding-bottom: px(32);
    }
  }
</style>
